import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const check = async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        try {
          const { data } = await api.post("/auth/refresh");
          setUser(data);
        } catch (err) {
          setUser(false);
        }
      }
    };
    check();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } finally { setUser(false); }
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div data-testid="admin-loading" className="grid min-h-screen place-items-center font-mono text-xs uppercase tracking-[0.2em] text-zinc-600">Checking session…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
